// @ts-nocheck
import { createRef } from "react";
import resolveConfig from "tailwindcss/resolveConfig";
import tailwindConfig from "common/tailwindConfig";

export const resolvedTailwindConfig = resolveConfig(tailwindConfig);

export const notistackRef = createRef();

export const APP_SIDE_MENU_WIDTH = 270;
export const DOCUMENT_PREVIEW_SIDE_MENU_WIDTH = 500;
export const ACTION_DRAWER_WIDTH = 500;

export const MediaQueryBreakpointEnum = {
  "2xl": `(min-width: ${resolvedTailwindConfig.theme.screens["2xl"]})`,
  lg: `(min-width: ${resolvedTailwindConfig.theme.screens.lg})`,
  md: `(min-width: ${resolvedTailwindConfig.theme.screens.md})`,
  sm: `(min-width: ${resolvedTailwindConfig.theme.screens.sm})`,
  xl: `(min-width: ${resolvedTailwindConfig.theme.screens.xl})`,
};

export const DateFormatEnum = {
  HYPHEN: "yyyy-MM-dd",
  SPACE_MM_yyyy: "MM yyyy",
  SPACE_dd_MM_yyyy: "dd MM yyyy",
  FORWARD_SLASH: "yyyy/MM/dd",
  MONTH_HYPHEN_YEAR: "MM-yyyy",
};

export const TABLE_PAGINATION_DEFAULT = {
  offset: 0,
  limit: 500,
};

export const TABLE_PAGINATION_DEFAULT_PAYMENT_INSTRUCTIONS = {
  Page: 0,
  PageSize: 20,
};

export const RouteEnum = {
  LOGIN: "/login",
  LOGIN_VERIFICATION: "/login/verify",
  DASHBOARD: "/",
  SEQUEST_REQUEST: "/feex/request",
  SEQUEST_REQUEST_DASHBOARD: "/feex/dashboard",
  SEQUEST_REQUEST_DASHBOARD_OVERDUETICKETS:
    "/feex/dashboard/overdue-tickets/:id",
  SEQUEST_REQUEST_DETAILS: "/feex/request/:id",
  SEQUEST_REQUEST_HISTORY: "/feex/request/history/:id",
  SEQUEST_REQUEST_DISCOURSE: "/feex/request/discourse/:id",
  SEQUEST_REQUEST_FILES: "/feex/request/files/:id",

  SEQUEST_EXCEPTION: "sequest/exception",
  SEQUEST_OPPORTUNITY: "sequest/opportunity",
  SEQUEST_OPPORTUNITY_DETAILS: "/sequest/opportunity/:id",

  LOAN_MANAGEMENT: "/loan-management",
  LOAN_MANAGEMENT_BULK_WRITE_OFF: "/loan-management/bulk-write-off",
  LOAN_MANAGEMENT_BULK_WRITE_OFF_BATCH_DETAIL_LIST:
    "/loan-management/bulk-write-off/:id",
  LOAN_MANAGEMENT_EMPLOYER_LOAN_APPROVAL_LIST:
    "/loan-management/employer-approval",
  LOAN_MANAGEMENT_EMPLOYER_LOAN_APPROVAL_DETAIL:
    "/loan-management/employer-approval/:id",

  SEQUEST_WORKFLOW: "sequest/workflow",
  SEQUEST_EXCEPTION_DETAILS: "/sequest/exception/:id",
  SEQUEST_EXCEPTION_HISTORY: "/sequest/exception/history/:id",
  SEQUEST_EXCEPTION_DISCOURSE: "/sequest/exception/discourse/:id",
  SEQUEST_EXCEPTION_FILES: "/sequest/exception/files/:id",
  EDR: "/edr",
  EDR_DETAILS: "/edr/:id",
  EDR_CREATE: "/edr/create",
  EDR_EDIT: "/edr/:id/edit",
  EDR_RECONCILLATION: "/edr/EDRReconcilliations",
  EDR_RECONCILLATION_DETAILS:
    "/edr/EDRReconcilliations/:id/:payPointShortName/:payPointName",
  EDR_RECONCILLATION_DASHBOARD:
    "/edr/EDRReconcilliations/:payPointId/:uploadId",
  EDR_UNPROCESSED: "/edr/unprocessed",
  EDR_UNPROCESSED_DETAILS: "/edr/unprocessed/:id",
  EDR_PARTIALLY_PROCESSED: "/edr/partially-processed",
  EDR_PARTIALLY_PROCESSED_DETAILS: "/edr/partially-processed/:id",
  EDR_PARTIALLY_PROCESSED_DETAILS_BREAKDOWN_DETAILS:
    "/edr/partially-processed/:id/breakdown/:tid",
  EDR_FULLY_PROCESSED: "/edr/fully-processed",
  EDR_FULLY_PROCESSED_DETAILS: "/edr/fully-processed/:id",
  EDR_FULLY_PROCESSED_DETAILS_BREAKDOWN_DETAILS:
    "/edr/fully-processed/:id/breakdown/:tid",
  EDR_PAYPOINT_REPORT: "/edr/paypoint",
  EDR_PAYPOINT_SETTLEMENT_REPORT: "/edr/paypoint-settlement-report",
  EDR_PAYPOINT_SETTLEMENT_REPORT_DETAILS: "/edr/paypoint-settlement-report/:id",
  EDR_OVERDRAFT_APPROVALS: "/edr/edr-overdraft-approvals",
  EDR_PAYPOINT_REPORT_DETAILS: "/edr/paypoint/:id",
  EDR_PAYPOINT_REPORT_DETAILS_BREAKDOWN_DETAILS:
    "/edr/paypoint/:id/breakdown/:tid",
  EDR_BULK_REVERSAL: "/edr/bulk-reversal",
  EDR_APPROVAL: "/edr/approval",
  EDR_OVERDUE_LOAN: "/edr/overdue-loan",
  LOAN_DISBURSAL_EXCEPTION: "/edr/loan-disbursal-exception",
  EDR_FUND_VENDORS: "/edr/fund-vendors",
  EDR_REMITA_MANDATE: "/edr/remita-mandate",
  EDR_REMITA_MANDATE_DETAILS: "/edr/remita-mandate/:batchNumber",
  INSIGHT: "/insight",

  RECOVERY: "/recovery-management/recovery",
  RECOVERY_COLLECTION: "/recovery-management/recovery-collection",
  RECOVERY_DETAILS: "/recovery-management/recovery/:id",
  RECOVERY_HISTORY: "/recovery-management/recovery/history/:id",
  RECOVERY_DISCOURSE: "/recovery-management/recovery/discourse/:id",
  RECOVERY_FILES: "/recovery-management/recovery/files/:id",

  TELESALES: "/telesales-management/telesales",
  TELESALES_DETAILS: "/telesales-management/telesales/:id",
  TELESALES_HISTORY: "/telesales-management/telesales/history/:id",
  TELESALES_DISCOURSE: "/telesales-management/telesales/discourse/:id",
  TELESALES_FILES: "/telesales-management/telesales/files/:id",

  TELESALES_HOT_LEADS: "/telesales-management/hotleads",
  TELESALES_HOT_LEADS_DETAILS: "/telesales-management/hotleads/:id",
  TELESALES_HOT_LEADS_HISTORY: "/telesales-management/hotleads/history/:id",
  TELESALES_HOT_LEADS_DISCOURSE: "/telesales-management/hotleads/discourse/:id",
  TELESALES_HOT_LEADS_FILES: "/telesales-management/hotleads/files/:id",

  TELESALES_DROPOFF_LOANS: "/telesales-management/dropoffloans",
  TELESALES_DROPOFF_INTERSWITCH: "/telesales-management/dropoffinterswitch",
  TELESALES_DROPOFF_LOANS_DETAILS: "/telesales-management/dropoffloans/:id",
  TELESALES_DROPOFF_LOANS_HISTORY:
    "/telesales-management/dropoffloans/history/:id",
  TELESALES_DROPOFF_LOANS_DISCOURSE:
    "/telesales-management/dropoffloans/discourse/:id",
  TELESALES_DROPOFF_LOANS_FILES: "/telesales-management/dropoffloans/files/:id",

  LOAN_UNDER_WRITING: "/loan-under-writing",
  LOAN_UNDER_WRITING_PENDING: "/loan-under-writing/pending",
  LOAN_UNDER_WRITING_PENDING_APPROVAL: "/loan-under-writing/pending-approval",
  LOAN_UNDER_WRITING_COLLECTIONS: "/loan-under-writing/collections",

  CRM: "/crm",
  CRM_LEADS: "/crm/leads",
  CRM_LEAD_GENERATION: "/crm/lead-generation",
  CRM_LEAD_GENERATION_DETAILS: "/crm/lead-generation/:batchId",
  CRM_CLIENTS: "/crm/clients",
  CRM_SAVINGS_APPROVAL: "/crm/savings-approval",
  CRM_CLIENTS_DETAILS: "/crm/clients/:id",
  CRM_CLIENTS_ADD: "/crm/clients/add",
  CRM_CLIENTS_ADD_INSTANCE: "/crm/clients/add/:id",
  CRM_CLIENTS_ADD_FROM_LEAD: "/crm/clients/add/:id/lead/:leadId",
  CRM_CLIENTS_EDIT: "/crm/clients/edit",
  CRM_CLIENTS_LOAN_ADD: "/crm/clients/:id/loan/add",
  CRM_CLIENTS_LOAN_EDIT: "/crm/clients/:id/loan/edit/:loanId",
  CRM_CLIENTS_LOAN_DETAILS: "/crm/clients/:id/loan/:loanId",
  CRM_LEADS_DETAILS: "/crm/leads/:id",
  CRM_LEADS_ADD: "/crm/leads/add",
  CRM_LEADS_UPLOAD: "/crm/leads/upload",
  CRM_LEADS_ADD_INSTANCE: "/crm/leads/add/:id",
  CRM_LEADS_EDIT: "/crm/leads/edit",
  CRM_LEADS_LOAN_ADD: "/crm/leads/:id/loan/add",
  CRM_LEADS_LOAN_EDIT: "/crm/leads/:id/loan/edit/:loanId",
  CRM_LEADS_LOAN_DETAILS: "/crm/leads/:id/loan/:loanId",
  CRM_BUSINESS_BANKING: "/crm/business-banking",
  CRM_BUSINESS_BANKING_WALLET_ADD: "/crm/business-banking/:id/wallet/add",
  CRM_BUSINESS_BANKING_WALLET_EDIT:
    "/crm/business-banking/:id/wallet/:walletId/edit",
  CRM_BUSINESS_BANKING_DETAILS: "/crm/business-banking/:id",
  CRM_BUSINESS_BANKING_WALLET_DETAILS:
    "/crm/business-banking/:id/wallet/:walletId/legalform/:legalformId",
  CRM_BUSINESS_BANKING_REOCCURRING_FIXED_DEPOSIT_DETAILS:
    "/crm/business-banking/:id/reoccurring-fixed-deposit/:fixedDepositId",
  CRM_BUSINESS_BANKING_REOCCURRING_FIXED_DEPOSIT_ADD:
    "/crm/business-banking/:id/reoccurring-fixed-deposit/add",
  CRM_BUSINESS_BANKING_REOCCURRING_FIXED_DEPOSIT_EDIT:
    "/crm/business-banking/:id/reoccurring-fixed-deposit/edit/:depositId",
  CRM_BUSINESS_BANKING_FIXED_DEPOSIT_DETAILS:
    "/crm/business-banking/:id/fixed-deposit/:fixedDepositId",
  CRM_BUSINESS_BANKING_FIXED_DEPOSIT_ADD:
    "/crm/business-banking/:id/fixed-deposit/add",
  CRM_BUSINESS_BANKING_FIXED_DEPOSIT_EDIT:
    "/crm/business-banking/:id/fixed-deposit/edit/:depositId",
  CRM_BUSINESS_BANKING_OFFICES_DETAILS:
    "/crm/business-banking/:id/office/:officeId",
  CRM_BUSINESS_BANKING_ADD: "/crm/business-banking/add",
  CRM_BUSINESS_BANKING_EDIT: "/crm/business-banking/edit/:id",
  CRM_BUSINESS_BANKING_TRANSFER:
    "/crm/business-banking/:businessId/:walletId/transfer",
  CRM_BUSINESS_BANKING_TRANSFER_BULK:
    "/crm/business-banking/:businessId/:walletId/transfer/bulk-upload",
  CRM_BUSINESS_BANKING_TRANSFER_BULK_DETAILS:
    "/crm/business-banking/:businessId/:walletId/transfer/bulk-upload/:id",
  ACCOUNTING: "/accounting",
  ACCOUNTING_JOURNAL_ENTRIES_ADD: "/accounting/journalentries/add",
  ACCOUNTING_JOURNAL_ENTRIES_DETAILS: "/accounting/journalentries/:id",
  ACCOUNTING_JOURNAL_ENTRIES_SEARCH: "/accounting/journalentries/search",
  ADMINISTRATION: "/administration",
  ADMINISTRATION_PRODUCTS: "/products",
  NOTIFICATION: "/notification",
  ADMINISTRATION_PRODUCTS_LOANS: "/products/loans",
  ADMINISTRATION_PRODUCTS_CHARGES: "/products/charges",
  ADMINISTRATION_PRODUCTS_PENDING_CHARGES: "/products/charges/pendingcharges",
  ADMINISTRATION_PRODUCTS_PENDING_CHARGES_DETAILS:
    "/products/charges/pendingchargesdetails/:id",
  ADMINISTRATION_PRODUCTS_CHARGES_ADD: "/products/charges/add",
  ADMINISTRATION_PRODUCTS_CHARGES_EDIT: "/products/charges/edit/:id",
  ADMINISTRATION_PRODUCTS_CHARGES_DETAILS: "/products/charges/:id",
  ADMINISTRATION_PRODUCTS_RATES: "/products/rates",
  ADMINISTRATION_PRODUCTS_RATES_ADD: "/products/rates/add",
  ADMINISTRATION_PRODUCTS_RATES_EDIT: "/products/rates/edit/:id",
  ADMINISTRATION_PRODUCTS_RATES_DETAILS: "/products/rates/:id",
  ADMINISTRATION_PRODUCTS_FLOATING_RATES: "/products/floatingrates",
  ADMINISTRATION_PRODUCTS_FLOATING_RATES_ADD: "/products/floatingrates/add",
  ADMINISTRATION_PRODUCTS_FLOATING_RATES_EDIT:
    "/products/floatingrates/edit/:id",
  ADMINISTRATION_PRODUCTS_FLOATING_RATES_DETAILS: "/products/floatingrates/:id",
  ADMINISTRATION_PRODUCTS_TAX_COMPONENTS: "/products/taxcomponents",
  ADMINISTRATION_PRODUCTS_TAX_COMPONENTS_ADD: "/products/taxcomponents/add",
  ADMINISTRATION_PRODUCTS_TAX_COMPONENTS_EDIT:
    "/products/taxcomponents/edit/:id",
  ADMINISTRATION_PRODUCTS_TAX_COMPONENTS_DETAILS: "/products/taxcomponents/:id",
  ADMINISTRATION_PRODUCTS_TAX_COMPONENT_GROUPS: "/products/taxconfigurations",
  ADMINISTRATION_PRODUCTS_LOAN_DECIDER: "/products/loan-decider",
  ADMINISTRATION_PRODUCTS_LOAN_DECIDER_DETAILS: "/products/loan-decider/:id",
  ADMINISTRATION_PRODUCTS_TAX_GROUPS: "/products/taxgroups",
  ADMINISTRATION_PRODUCTS_TAX_GROUPS_ADD: "/products/taxgroups/add",
  ADMINISTRATION_PRODUCTS_TAX_GROUPS_EDIT: "/products/taxgroups/edit/:id",
  ADMINISTRATION_PRODUCTS_TAX_GROUPS_DETAILS: "/products/taxgroups/:id",
  ADMINISTRATION_LOAN_PRODUCT_ADD: "/products/loans/add",
  ADMINISTRATION_LOAN_PRODUCT_PENDING_LOAN_PRODUCT:
    "/products/loans/pendingloanproduct",
  ADMINISTRATION_LOAN_PRODUCT_PENDING_LOAN_PRODUCT_DETAILS:
    "/products/loans/pendingloanproductdetails/:id",
  ADMINISTRATION_LOAN_PRODUCT_EDIT: "/products/loans/edit/:id",
  ADMINISTRATION_PRODUCTS_LOANS_DETAILS: "/products/loans/:id",
  ADMINISTRATION_PRODUCTS_USSD_PREQUALIFICATION:
    "/products/ussd-prequalification",
  ADMINISTRATION_PRODUCTS_USSD_PREQUALIFICATION_HISTORY:
    "/products/ussd-prequalification/:stateId/:productId",
  FIXED_DEPOSIT_PRODUCT: "/products/fixed-deposits",
  FIXED_DEPOSIT_PRODUCT_ADD: "/products/fixed-deposits/add",
  FIXED_DEPOSIT_PRODUCT_EDIT: "/products/fixed-deposits/edit/:id",
  FIXED_DEPOSIT_PRODUCT_DETAILS: "/products/fixed-deposits/:id",
  CHARTOFACCOUNTS: "/accounting/chartofaccounts",
  CHARTOFACCOUNTS_ADD: "/accounting/chartofaccounts/add",
  CHARTOFACCOUNTS_ADD_SUBLEDGER:
    "/accounting/chartofaccounts/add/subledger/:id",
  CHARTOFACCOUNTS_EDIT: "/accounting/chartofaccounts/edit/:id",
  CHARTOFACCOUNTS_DETAILS: "/accounting/chartofaccounts/:id",
  CRM_EMPLOYER: "/crm/employer",
  CRM_EMPLOYER_ADD: "/crm/employer/add",
  CRM_EMPLOYER_ADD_BRANCH: "/crm/employer/add-branch/:parentId",
  CRM_EMPLOYER_EDIT: "/crm/employer/add/:id",
  CRM_EMPLOYER_DETAILS: "/crm/employer/:id",
  CRM_CLIENT: "CRM_CLIENT",
  CRM_LEAD: "CRM_LEAD",
  CRM_LOAN: "CRM_LOAN",
  CRM_WALLET: "CRM_WALLET",
  CRM_TEMPLATE: "CRM_TEMPLATE",
  CRM_NOTE: "CRM_NOTE",
  CRM_LOAN_DOCUMENT: "CRM_LOAN_DOCUMENT",
  CRM_CLIENT_SUMMARY: "CRM_CLIENT_SUMMARY",
  USER: "/users",
  USER_ADD: "/user/add",
  USER_EDIT: "/user/edit/:id",
  USER_DETAILS: "/user/:id",
  STAFF: "/staff",
  STAFF_EDIT: "/staff/edit/:id",
  STAFF_DETAILS: "/staff/:id",
  SYSTEM: "/system",
  CATEGORY_MANAGEMENT: "/system/category-unit-list",
  CATEGORY_MANAGEMENT_BYUNIT_ID: "/system/category-unit-list/:id",
  SUBCATEGORY_MANAGEMENT_ID: "/system/category-unit-list/:id/:subid",
  DOCUMENT_CONFIGURATIONS: "/system/document-configurations",
  SURVEYS: "/system/surveys",
  SURVEYS_ADD: "/system/surveys/add",
  SURVEYS_EDIT: "/system/surveys/edit/:id",
  SURVEYS_CLIENT: "/_/surveys/:surveyId/:userId/:clientId",

  FAQ: "/system/faqs",
  FAQ_ADD: "/system/faqs/add",
  FAQ_EDIT: "/system/faqs/edit/:id",

  ROLES: "/system/roles",
  ROLES_ADD: "/system/roles/add",
  ROLES_PERMISSIONS_ADD: "/system/roles/permissions/:id",
  ROLES_EDIT: "/system/roles/edit/:id",
  DOCUMENT_CONFIGURATIONS_ADD: "/system/document-configurations/add",
  DOCUMENT_CONFIGURATIONS_EDIT: "/system/document-configurations/edit/:id",
  DOCUMENT_CONFIGURATIONS_SETTINGS:
    "/system/document-configurations/settings/:id",
  ADMINISTRATION_PRODUCTS_PRODUCT_MIX: "/products/product-mix",
  ADMINISTRATION_PRODUCTS_PRODUCT_MIX_ADD: "/products/product-mix/add",
  ADMINISTRATION_PRODUCTS_PRODUCT_MIX_EDIT:
    "/products/product-mix/edit/:productId",
  CLIENT_APPROVAL: "/loan-under-writing/client-approval",
  WACS_APPROVAL: "/loan-under-writing/wacs-approval",
  UNDERWRITER_LOAN_LIMIT_APPROVAL:
    "/loan-under-writing/under-writer-loan-limit-list",
  CRM_CLIENT_FIXED_DEPOSIT_ADD: "/crm/clients/:id/fixed-deposit/add",
  CRM_CLIENT_FIXED_DEPOSIT_EDIT:
    "/crm/clients/:id/fixed-deposit/edit/:depositId",
  RECOVERY_PAYMENT_INSTRUCTIONS: "/recovery/collection-instructions",
  ADMINISTRATION_ORGANISATION: "/administration/organizations",
  ADMINISTRATION_ORGANISATION_EMPLOYEES:
    "/administration/organizations/employees",
  ADMINISTRATION_ORGANISATION_EMPLOYEES_ADD:
    "/administration/organizations/employees/add",
  ADMINISTRATION_ORGANISATION_EMPLOYEES_EDIT:
    "/administration/organizations/employees/edit/:id",
  REPORT: "/reports/:R_reportCategory",
  REPORT_DETAILS: "/reports/:R_reportCategory/:R_reportListing/:id",
  CRM_CLIENTS_FIXED_DEPOSIT_DETAILS:
    "/crm/clients/:id/fixed-deposit/:fixedDepositId",
  CRM_CLIENTS_WALLET_DETAILS:
    "/crm/clients/:id/wallet/:walletId/legalform/:legalformId",
  RECURRING_DEPOSIT_PRODUCT: "/products/recurring-deposits",
  RECURRING_DEPOSIT_PRODUCT_ADD: "/products/recurring-deposits/add",
  RECURRING_DEPOSIT_PRODUCT_EDIT: "/products/recurring-deposits/edit/:id",
  RECURRING_DEPOSIT_PRODUCT_DETAILS: "/products/recurring-deposits/:id",
  CRM_CLIENTS_LOAN_AGREEMENT_FORM: "/_/:id/loan/:loanId/loan-agreement-form",
  CREDIT_DIRECT_PAY: "/_/credit-direct-pay/:payRef",
  CREDIT_DECISIONING: "/product/creditdecisioning",
  REMITA_MANDATE: "/_/remita-mandate/:mandateId/:requestId",
  RESCHEDULE_LOAN: "/recovery-management/reschedule-loan",
  RESCHEDULE_LOAN_DETAIL: "/recovery-management/reschedule-loan/:id",
  RECOVERY_MANAGEMENT: "/recovery-management",
  CRM_CLIENT_REOCCURRING_FIXED_DEPOSIT_ADD:
    "/crm/clients/:id/reoccurring-fixed-deposit/add",
  CRM_CLIENT_REOCCURRING_FIXED_DEPOSIT_EDIT:
    "/crm/clients/:id/reoccurring-fixed-deposit/edit/:depositId",
  CRM_CLIENTS_REOCCURRING_FIXED_DEPOSIT_DETAILS:
    "/crm/clients/:id/reoccurring-fixed-deposit/:fixedDepositId",
  CRM_VENDOR: "/crm/vendor",
  CRM_VENDOR_ADD: "/crm/vendor/add",
  CRM_VENDOR_EDIT: "/crm/vendor/add/:id",
  CRM_VENDOR_DETAILS: "/crm/vendor/:id",

  CRM_LENDER: "/crm/lender",
  CRM_LENDER_ADD: "/crm/lender/add",
  CRM_LENDER_EDIT: "/crm/lender/add/:id",
  CRM_LENDER_DETAILS: "/crm/lender/:id",

  CRM_LEADS_LOAN_DETAILS_PENDING_VALIDATION: "/crm/clients/:id/loan/:loanId/x",
  BANK_SCHEDULE: "/bank-schedule",
  BANK_SCHEDULE_DETAILS: "/bank-schedule/:id",

  CLIENT_CHANGE_LOGS: "/crm/clients/:id/logs",
  DISBURSEMENTS: "/disbursements",
  DISBURSEMENTS_DETAILS: "/disbursements/:id",
  REPAYMENTS: "/repayments",
  MERCHANTS: "/merchants",
  RECONCILIATION_EXCEPTIONS: "/reconciliation/exceptions",
  RECONCILIATION_EXCEPTIONS_DETAILS: "/reconciliation/exceptions/:uniqueId",
  SMS_CAMPAIGN: "/organizations/smscampaign",
  SMS_CAMPAIGN_ADD: "/organizations/smscampaign/add",
  SMS_CAMPAIGN_EDIT: "/organizations/smscampaign/:id/edit",
  SMS_CAMPAIGN_DETAILS: "/organizations/smscampaign/:id",

  CRM_PAYPOINT: "/crm/paypoint",
  CRM_PAYPOINT_ADD: "/crm/paypoint/add",
  CRM_PAYPOINT_EDIT: "/crm/paypoint/add/:id",
  CRM_PAYPOINT_DETAILS: "/crm/paypoint/:id",
  APP_VERSION: "/_/app-version",
  NIP_TRANSACTION: "/nip-transaction",
  NIP_TRANSACTION_DETAILS: "/nip-transaction/:id",
  OUTFLOW_TRANSACTION: "/outflow-transaction",
  OUTFLOW_TRANSACTION_DETAILS: "/outflow-transaction/:id",
  IMPAIRMENT_AUTOMATION: "/impairment",
  IMPAIRMENT_AUTOMATION_DETAILS: "/impairment/:id",
  IMPAIRMENT_AUTOMATION_STATE_DETAILS: "/impairment/state/:state",
};

export const RtkqTagEnum = {
  USER: "USER",
  CRM_CLIENT: "CRM_CLIENT",
  UNDERWRITER_LOAN_LIMIT_APPROVAL: "UNDERWRITER_LOAN_LIMIT_APPROVAL",
  CRM_EMPLOYER: "CRM_EMPLOYER",
  CRM_BUSINESS_BANKING: "CRM_BUSINESS_BANKING",
  CRM_BUSINESS_BANKING_KYB: "CRM_BUSINESS_BANKING_KYB",
  CRM_BUSINESS_BANKING_OFFICES: "CRM_BUSINESS_BANKING_OFFICES",
  CRM_BUSINESS_BANKING_OFFICES_SAVINGS: "CRM_BUSINESS_BANKING_OFFICES_SAVINGS",
  CRM_BUSINESS_BANKING_OFFICES_ADDRESS: "CRM_BUSINESS_BANKING_OFFICES_ADDRESS",
  CRM_CLIENT_LOAN_EDR: "CRM_CLIENT_LOAN_EDR",
  CRM_LEAD: "CRM_LEAD",
  CRM_LOAN: "CRM_LOAN",
  CRM_WALLET: "CRM_WALLET",
  CRM_TEMPLATE: "CRM_TEMPLATE",
  CRM_NOTE: "CRM_NOTE",
  CRM_PAYPOINT: "CRM_PAYPOINT",
  CRM_DOCUMENT: "CRM_DOCUMENT",
  CRM_LOAN_DOCUMENT: "CRM_LOAN_DOCUMENT",
  SEQUEST: "SEQUEST",
  ENGAGEMENT_NOTES: "ENGAGEMENT_NOTES",
  SEQUEST_EXCEPTION: "SEQUEST_EXCEPTION",
  SEQUEST_COLLECTION: "SEQUEST_COLLECTION",
  SEQUEST_COLLECTION_METRICS: "SEQUEST_COLLECTION_METRICS",
  SEQUEST_COLLECTION_HISTORY: "SEQUEST_COLLECTION_HISTORY",
  SEQUEST_OPPORTUNITY: "SEQUEST_OPPORTUNITY",
  SEQUEST_WORKFLOW: "SEQUEST_WORKFLOW",
  SEQUEST_DETAILS: "SEQUEST_DETAILS",
  SEQUEST_HISTORY: "SEQUEST_HISTORY",
  SEQUEST_DISCOURSE: "SEQUEST_DISCOURSE",
  SAVINGS_APPROVAL: "SAVINGS_APPROVAL",
  RECOVERY: "RECOVERY",
  RECOVERY_DETAILS: "RECOVERY_DETAILS",
  SEQUEST_FILES: "SEQUEST_FILES",
  CRM_CLIENT_SUMMARY: "CRM_CLIENT_SUMMARY",
  CRM_CLIENT_ACCOUNT: "CRM_CLIENT_ACCOUNT",
  RATE_PRODUCT: "RATE_PRODUCT",
  CHARGE_PRODUCT: "CHARGE_PRODUCT",
  ADMINISTRATION_PRODUCTS_PENDING_CHARGES:
    "ADMINISTRATION_PRODUCTS_PENDING_CHARGES",
  ADMINISTRATION_PRODUCTS_PENDING_CHARGES_DETAILS:
    "ADMINISTRATION_PRODUCTS_PENDING_CHARGES_DETAILS",
  ADMINISTRATION_LOAN_PRODUCT_PENDING_LOAN_PRODUCT:
    "ADMINISTRATION_LOAN_PRODUCT_PENDING_LOAN_PRODUCT",
  ADMINISTRATION_LOAN_PRODUCT_PENDING_LOAN_PRODUCT_DETAILS:
    "ADMINISTRATION_LOAN_PRODUCT_PENDING_LOAN_PRODUCT_DETAILS",
  EDR_INFLOW: "FCMB",
  EDR_NOTE: "EDR_NOTE",
  EDR_TRANSACTION: "EDR_TRANSACTION",
  EDR_TRANSACTION_JOURNAL_ENTRY: "EDR_TRANSACTION_JOURNAL_ENTRY",
  EDR_TRANSACTION_NOTE: "EDR_TRANSACTION_NOTE",
  EDR_TRANSACTION_UNPROCESSED: "EDR_TRANSACTION_UNPROCESSED",
  EDR_RECONCILLATION_DETAILS: "EDR_RECONCILLATION_DETAILS",
  EDR_RECONCILLATION: "EDR_RECONCILLATION",
  EDR_RECONCILLATION_DASHBOARD: "EDR_RECONCILLATION_DASHBOARD",

  EDR_PAYPOINT_SETTLEMENT_REPORT_DETAILS:
    "EDR_PAYPOINT_SETTLEMENT_REPORT_DETAILS",
  EDR_PAYPOINT_SETTLEMENT_REPORT: "EDR_PAYPOINT_SETTLEMENT_REPORT",

  CHARTOFACCOUNTS_DELETE: "CHARTOFACCOUNTS_DELETE",
  DOCUMENT_CONFIGURATION: "DOCUMENT_CONFIGURATION",
  DOCUMENT_CONFIGURATION_SETTINGS: "DOCUMENT_CONFIGURATION_SETTINGS",
  LOAN_PRODUCTS: "LOAN_PRODUCTS",
  SAVINGS_PRODUCTS: "SAVINGS_PRODUCTS",
  BANK_STATEMENTS: "BANK_STATEMENTS",
  FIXED_DEPOSIT_PRODUCT: "FIXED_DEPOSIT_PRODUCT",
  SURVEYS: "SURVEYS",
  CLIENT_SURVEY: "CLIENT_SURVEY",
  ADMINISTRATION_ORGANISATION_EMPLOYEES:
    "ADMINISTRATION_ORGANISATION_EMPLOYEES",
  RECOVERY_PAYMENT_INSTRUCTIONS: "RECOVERY_PAYMENT_INSTRUCTIONS",
  FIXED_DEPOSIT: "FIXED_DEPOSIT",
  STANDING_INSTRUCTIONS: "STANDING_INSTRUCTIONS",
  EMPLOYER_PRODUCTS: "EMPLOYER_PRODUCTS",
  CRM_TRACKING: "CRM_TRACKING",
  CRM_ACTIVITIES: "CRM_ACTIVITIES",
  CRM_CLIENT_CONFIGURATION: "CRM_CLIENT_CONFIGURATION",
  LOAN_AGREEMENT_FORM: "LOAN_AGREEMENT_FORM",
  CDL_PAY_DETAILS: "CDL_PAY_DETAILS",
  RESCHEDULE_LOAN: "RESCHEDULE_LOAN",
  EDR_OVERDUE_LOAN: "EDR_OVERDUE_LOAN",
  ROLE: "ROLE",
  CRM_VENDOR: "CRM_VENDOR",
  CRM_VENDOR_ADDRESS: "CRM_VENDOR_ADDRESS",
  CRM_VENDOR_BANK: "CRM_VENDOR_BANK",
  CRM_VENDOR_SUMMARY: "CRM_VENDOR_SUMMARY",
  CRM_VENDOR_ACCOUNT: "CRM_VENDOR_ACCOUNT",
  CRM_VENDOR_LOAN: "CRM_VENDOR_LOAN",

  CRM_LENDER_ADDRESS: "CRM_LENDER_ADDRESS",
  CRM_LENDER_BANK: "CRM_LENDER_BANK",
  CRM_LENDER_SUMMARY: "CRM_LENDER_SUMMARY",
  CRM_LENDER_ACCOUNT: "CRM_LENDER_ACCOUNT",
  CRM_LENDER_LOAN: "CRM_LENDER_LOAN",
  EDR_OVERDRAFT_APPROVAL_LIST: "CRM_OVERDRAFT_APPROVAL_LIST",

  BANK_SCHEDULE: "BANK_SCHEDULE",
  CRM_OFFICES: "CRM_OFFICES",
  USER_MANAGEMENT: "USER_MANAGEMENT",
  STAFF: "STAFF",
  DROPOFF_INTERSWITCH: "DROPOFF_INTERSWITCH",
  UNDERWRITING: "UNDERWRITING",
  LOAN_DECIDER: "LOAN_DECIDER",
  EDR_REPORT: "EDR_REPORT",
  EMPLOYER_LOAN_APPROVAL: "EMPLOYER_LOAN_APPROVAL",
  CLIENT_REQUESTS_LOGS: "CLIENT_REQUESTS_LOGS",
  DSR_CONFIG: "DSR_CONFIG",
  USSD_PREQUALIFICATION: "USSD_PREQUALIFICATION",
  RECONCILIATION_DISBURSEMENT: "RECONCILIATION_DISBURSEMENT",
  LOAN_RECONCILIATION_DISBURSEMENT: "LOAN_RECONCILIATION_DISBURSEMENT",
  RECONCILIATION_EXCEPTIONS: "RECONCILIATION_EXCEPTIONS",
  CHARGES: "CHARGES",
  LOAN_DISBURSAL_EXCEPTION: "LOAN_DISBURSAL_EXCEPTION",
  SMS_CAMPAIGN: "SMS_CAMPAIGN",
  SMS_CAMPAIGN_CONFIG: "SMS_CAMPAIGN_CONFIG",
  LOAN_MANDATE: "LOAN_MANDATE",
  FAQ: "FAQ",
  CHANNELS: "CHANNELS",
  CRM_LEAD_GENERATION: "CRM_LEAD_GENERATION",
  CRM_LEAD_GENERATION_DETAILS: "CRM_LEAD_GENERATION_DETAILS",
  ICALLY_INTERACTION: "ICALLY_INTERACTION",
  REPAYMENT_METHOD: "REPAYMENT_METHOD",
  FCMB: "FCMB",
  PAYPOINT: "PAYPOINT",
  CHANNEL_WRAPPER: "CHANNEL_WRAPPER",
  CATEGORY_MANAGEMENT: "CATEGORY_MANAGEMENT",
  CATEGORY_MANAGEMENT_BYUNIT_ID: "CATEGORY_MANAGEMENT_BYUNIT_ID",
  SUBCATEGORY_MANAGEMENT_ID: "SUBCATEGORY_MANAGEMENT_ID",
  LINK_PROCESSOR: "LINK_PROCESSOR",
  BULK_WRITE_OFF: "BULK_WRITE_OFF",
  WACS_APPROVAL: "WACS_APPROVAL",
  IMPAIRMENT_AUTOMATION: "IMPAIRMENT_AUTOMATION",

  THIRD_PARTY: "THIRD_PARTY",
  CRM_CLIENT_LOAN_TIMELINE: "CRM_CLIENT_LOAN_TIMELINE",
  LOAN_PRODUCT_GROUPS: "LOAN_PRODUCT_GROUPS",
  NIP_TRANSACTION: "NIP_TRANSACTION",
  NIP_TRANSACTION_BANK: "NIP_TRANSACTION_BANK",
  OUTFLOW_TRANSACTION: "OUTFLOW_TRANSACTION",
};

export const dateLocaleFormat = {
  LOCALE: "en",
  DATE_FORMAT: "dd MMMM yyyy",
};

export const dateMonths = [
  undefined,
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const DateConfig = {
  LOCALE: "en",
  FORMAT: "dd-MM-yyyy",
  FORMAT_JOURNALENTRIES: "dd MMMM yyyy",
  FORMAT_REPORTS: "yyyy-MM-dd",
  HYPHEN_dd_MM_yyyy: "dd-MM-yyyy",
  HYPHEN_MM_dd_yyyy: "MM-dd-yyyy",
  HYPHEN_yyyy_MM_dd: "yyyy-MM-dd",
  HYPHEN_yyyy_mm_dd: "yyyy-mm-dd",
  SPACE_dd_MM_yyyy: "dd MM yyyy",
  DATE_TIME_FORMAT: "dd MMMM yyyy HH:mm:ss",
  DATE_FORMAT_SMSCAMPIGN: "dd+MMMM+yyyy",
  EDR_RECONCILLATION_DATE_FORMAT: "MM-YYYY",
};

export const CurrencyEnum = {
  USD: {
    code: "USD",
    symbol: "\u0024",
  },
  US: {
    code: "USD",
    symbol: "\u0024",
  },
  NGN: {
    code: "NGN",
    symbol: "\u20A6",
  },
  NG: {
    code: "NGN",
    symbol: "\u20A6",
  },
  GHS: {
    code: "GHS",
    symbol: "\u20B5",
  },
  GH: {
    code: "GHS",
    symbol: "\u20B5",
  },
  KES: {
    code: "KES",
    symbol: "KE",
  },
  KE: {
    code: "KES",
    symbol: "KE",
  },
  RWF: {
    code: "RWF",
    symbol: "RW",
  },
  RW: {
    code: "RWF",
    symbol: "RW",
  },
  TZS: {
    code: "TZS",
    symbol: "TZ",
  },
  TZ: {
    code: "TZS",
    symbol: "TZ",
  },
  UGX: {
    code: "UGX",
    symbol: "UG",
  },
  UG: {
    code: "UGX",
    symbol: "UG",
  },
  ZAR: {
    code: "ZAR",
    symbol: "ZA",
  },
  ZA: {
    code: "ZAR",
    symbol: "ZA",
  },
  ZMW: {
    code: "ZMW",
    symbol: "ZM",
  },
  ZM: {
    code: "ZMW",
    symbol: "ZM",
  },
};

export const UIPermissionEnum = {
  // CLIENTS
  VIEW_OUTWARDTRANSACTIONS: "VIEW_OUTWARDTRANSACTIONS",
  READ_NIP: "READ_NIP",
  READ_CLIENT: "READ_CLIENT",
  CREATE_CLIENT: "CREATE_CLIENT",
  ACTIVATE_CLIENT: "ACTIVATE_CLIENT",
  ASSIGNSTAFF_CLIENT: "ASSIGNSTAFF_CLIENT",
  UPDATE_CLIENT: "UPDATE_CLIENT",
  APPROVE_UPDATE_CLIENT: "APPROVE_UPDATE_CLIENT",
  READ_ClientTrendsByWeek: "READ_ClientTrendsByWeek",
  READ_ClientTrendsByDay: "READ_ClientTrendsByDay",
  READ_ClientTrendsByMonth: "READ_ClientTrendsByMonth",
  CREATE_EMAIL_CHECKER: "CREATE_EMAIL_CHECKER",
  PAY_CLIENTCHARGE: "PAY_CLIENTCHARGE",
  PAY_CLIENTCHARGE_CHECKER: "PAY_CLIENTCHARGE_CHECKER",
  CREATE_RESET_PIN: "CREATE_RESET_PIN",
  APPROVE_CLIENT_UPDATE_REQUEST: "APPROVE_CLIENT_UPDATE_REQUEST",

  // LEADS
  READ_LEAD: "READ_LEAD",
  CREATE_LEAD: "CREATE_LEAD",
  UPDATE_LEAD: "UPDATE_LEAD",
  ACTIVATE_LEAD: "ACTIVATE_LEAD",
  GENERATE_LEAD: "GENERATE_LEAD",
  STAFF_LEAD: "STAFF_LEAD",
  DOWNLOAD_LEAD: "DOWNLOAD_LEAD",
  UPLOAD_LEAD: "UPLOAD_LEAD",

  // EMPLOYERS
  READ_EMPLOYER: "READ_EMPLOYER",

  // VENDOR
  READ_Vendor: "READ_Vendor",
  READ_VENDOR: "READ_VENDOR",
  CREATE_ADHOC: "CREATE_ADHOC",
  CREATE_ACCOUNTNUMBERFORMAT: "CREATE_ACCOUNTNUMBERFORMAT",
  CREATE_ACCOUNTTRANSFER: "CREATE_ACCOUNTTRANSFER",
  CREATE_ACCOUNTTRANSFER_CHECKER: "CREATE_ACCOUNTTRANSFER_CHECKER",
  CREATE_ACCOUNTINGRULE: "CREATE_ACCOUNTINGRULE",

  // LENDER
  READ_LENDER: "READ_LENDER",

  // SEQUEST
  READ_JOURNALENTRY: "READ_JOURNALENTRY",
  CREATE_JOURNALENTRY: "CREATE_JOURNALENTRY",
  CREATE_JOURNALENTRY_CHECKER: "CREATE_JOURNALENTRY_CHECKER",
  CREATESCHEDULEEXCEPTIONS_LOAN: "CREATESCHEDULEEXCEPTIONS_LOAN",
  CREATESCHEDULEEXCEPTIONS_LOAN_CHECKER:
    "CREATESCHEDULEEXCEPTIONS_LOAN_CHECKER",
  CREATE_SAVINGSACCOUNT: "CREATE_SAVINGSACCOUNT",
  CREATE_SAVINGSACCOUNTCHARGE: "CREATE_SAVINGSACCOUNTCHARGE",
  CREATE_SHAREACCOUNT: "CREATE_SHAREACCOUNT",
  CREATE_SHAREPRODUCT: "CREATE_SHAREPRODUCT",
  READ_SEQUEST_CUSTOMER: "READ_SEQUEST_CUSTOMER",
  READ_SEQUEST_MANAGE: "READ_SEQUEST_MANAGE",
  UPDATE_SEQUEST_MANAGE: "UPDATE_SEQUEST_MANAGE",
  CREATE_SEQUEST_MANAGE: "CREATE_SEQUEST_MANAGE",
  DELETE_SEQUEST_MANAGE: "DELETE_SEQUEST_MANAGE",

  // INTERACTIONS
  READ_INTERREQUEST: "READ_INTERREQUEST",
  CREATE_INTERREQUEST: "CREATE_INTERREQUEST",

  // REPORT
  READ_COLLECTION_REPORT: "READ_Collection Report",
  READ_REPORT: "READ_REPORT",
  READ_REPORTMAILINGJOB: "READ_REPORTMAILINGJOB",
  REPORTING_SUPER_USER: "REPORTING_SUPER_USER",
  CREATE_CREDITREPORT: "CREATE_CREDITREPORT",
  UPDATE_CREDITREPORT: "UPDATE_CREDITREPORT",
  READ_Disbursal_Report: "READ_Disbursal Report",

  // LOAN
  CDLRECOVERYREPAYMENT_LOAN: "CDLRECOVERYREPAYMENT_LOAN",
  CDLWRITEOFF_LOAN: "CDLWRITEOFF_LOAN",
  UPDATE_LOANCHARGE_CHECKER: "UPDATE_LOANCHARGE_CHECKER",
  CREATE_CHARGE_CHECKER: "CREATE_CHARGE_CHECKER",
  READ_LOAN: "READ_LOAN",
  CREATE_LOAN: "CREATE_LOAN",
  READ_EMAIL_CAMPAIGN: "READ_EMAIL_CAMPAIGN",
  SALES_APPROVALUNDO_LOAN: "SALES_APPROVALUNDO_LOAN",
  DISBURSETOSAVINGS_LOAN: "DISBURSETOSAVINGS_LOAN",
  ADJUST_LOAN: "ADJUST_LOAN",
  WAIVEINTERESTPORTION_LOAN: "WAIVEINTERESTPORTION_LOAN",
  CREATE_RESCHEDULELOAN: "CREATE_RESCHEDULELOAN",
  WRITEOFF_LOAN: "WRITEOFF_LOAN",
  CLOSE_LOAN: "CLOSE_LOAN",
  UPDATELOANOFFICER_LOAN: "UPDATELOANOFFICER_LOAN",
  DRAFT_LOAN: "DRAFT_LOAN",
  UPDATE_LOANCHARGE: "UPDATE_LOANCHARGE",
  APPROVE_LOAN: "APPROVE_LOAN",
  REJECT_LOAN: "REJECT_LOAN",
  WITHDRAW_LOAN: "WITHDRAW_LOAN",
  SALES_APPROVE_LOAN_CHECKER: "SALES_APPROVE_LOAN_CHECKER",
  SALES_APPROVE_LOAN: "SALES_APPROVE_LOAN",
  DISBURSE_LOAN_CHECKER: "DISBURSE_LOAN_CHECKER",
  SALES_APPROVALUNDO_LOAN_CHECKER: "SALES_APPROVALUNDO_LOAN_CHECKER",
  DISBURSE_LOAN: "DISBURSE_LOAN",
  APPROVE_LOAN_CHECKER: "APPROVE_LOAN_CHECKER",
  APPROVALUNDO_LOAN_CHECKER: "APPROVALUNDO_LOAN_CHECKER",
  APPROVE_SAVINGSACCOUNT_CHECKER: "APPROVE_SAVINGSACCOUNT_CHECKER",
  READ_LOANS_PENDING_APPROVAL: "READ_Loans Pending Approval",
  UPDATE_LOAN_CHECKER: "UPDATE_LOAN_CHECKER",
  ADJUST_LOAN_CHECKER: "ADJUST_LOAN_CHECKER",
  TRANSFERCLIENTS_GROUP: "TRANSFERCLIENTS_GROUP",
  TRANSFERCLIENTS_GROUP_CHECKER: "TRANSFERCLIENTS_GROUP_CHECKER",
  ASSIGNUNDERWRITER_LOAN: "ASSIGNUNDERWRITER_LOAN",
  LOANREPAYMENTTRANSITION_LOAN: "LOANREPAYMENTTRANSITION_LOAN",
  ACTIVATE_REPAYMENT_LOAN: "ACTIVATE_REPAYMENT_LOAN",
  ACTIVATE_DOWNPAYMENT_LOAN: "ACTIVATE_DOWNPAYMENT_LOAN",
  RESET_LAF_LOAN: "RESET_LAF_LOAN",
  DOWNLOAD_SCHEDULE_LOAN: "DOWNLOAD_SCHEDULE_LOAN",
  EMAIL_SCHEDULE_LOAN: "EMAIL_SCHEDULE_LOAN",
  SUCCESS_DISBURSEMENTQUEUE: "SUCCESS_DISBURSEMENTQUEUE",
  RETRY_DISBURSEMENTQUEUE: "RETRY_DISBURSEMENTQUEUE",
  READ_TRANSFER_FUND: "READ_TRANSFER_FUND",
  UNDERWITER_DASHBOARD_LOAN: "UNDERWITER_DASHBOARD_LOAN",

  ACTIVE_DROPDOWN: "ACTIVE_DROPDOWN",
  APPROVED_DROPDOWN: "APPROVED_DROPDOWN",
  CLOSED_OBLIGATIONS_MET_DROPDOWN: "CLOSED_OBLIGATIONS_MET_DROPDOWN",
  CLOSED_RESCHEDULE_OUTSTANDING_AMOUNT_DROPDOWN:
    "CLOSED_RESCHEDULE_OUTSTANDING_AMOUNT_DROPDOWN",
  CLOSED_WRITTEN_OFF_DROPDOWN: "CLOSED_WRITTEN_OFF_DROPDOWN",
  DRAFT_DROPDOWN: "DRAFT_DROPDOWN",
  OVERPAID_DROPDOWN: "OVERPAID_DROPDOWN",
  REJECTED_DROPDOWN: "REJECTED_DROPDOWN",
  SALES_SUBMITTED_AND_PENDING_APPROVAL_DROPDOWN:
    "SALES_SUBMITTED_AND_PENDING_APPROVAL_DROPDOWN",
  SUBMITTED_AND_PENDING_APPROVAL_DROPDOWN:
    "SUBMITTED_AND_PENDING_APPROVAL_DROPDOWN",
  TRANSFER_IN_PROGRESS_DROPDOWN: "TRANSFER_IN_PROGRESS_DROPDOWN",
  TRANSFER_ON_HOLD_DROPDOWN: "TRANSFER_ON_HOLD_DROPDOWN",
  WITHDRAWN_BY_CLIENT_DROPDOWN: "WITHDRAWN_BY_CLIENT_DROPDOWN",
  READ_LOAN_MANAGEMENT: "READ_LOAN_MANAGEMENT",
  READ_BULK_WRITEOFF: "READ_BULK_WRITEOFF",
  READ_EMPLOYER_LOAN_APPROVAL: "READ_EMPLOYER_LOAN_APPROVAL",

  // SURVEY
  REGISTER_SURVEY: "REGISTER_SURVEY",

  // FIXED DEPOSIT
  READ_FIXEDDEPOSITACCOUNT: "READ_FIXEDDEPOSITACCOUNT",
  POSTINTEREST_FIXEDDEPOSITACCOUNT: "POSTINTEREST_FIXEDDEPOSITACCOUNT",
  WITHDRAW_FIXEDDEPOSITACCOUNT: "WITHDRAW_FIXEDDEPOSITACCOUNT",
  POSTINTEREST_FIXEDDEPOSITACCOUNT_CHECKER:
    "POSTINTEREST_FIXEDDEPOSITACCOUNT_CHECKER",
  POSTINTEREST_SAVINGSACCOUNT: "POSTINTEREST_SAVINGSACCOUNT",
  PREPARE_INTERTRANSFER: "PREPARE_INTERTRANSFER",
  CLOSE_FIXEDDEPOSITACCOUNT: "CLOSE_FIXEDDEPOSITACCOUNT",
  PREMATURECLOSE_FIXEDDEPOSITACCOUNT: "PREMATURECLOSE_FIXEDDEPOSITACCOUNT",
  READPENDINGCLOSE_FIXEDDEPOSITACCOUNT: "READPENDINGCLOSE_FIXEDDEPOSITACCOUNT",
  APPROVEPENDINGCLOSE_FIXEDDEPOSITACCOUNT:
    "APPROVEPENDINGCLOSE_FIXEDDEPOSITACCOUNT",
  UNDOPENDINGCLOSE_FIXEDDEPOSITACCOUNT: "UNDOPENDINGCLOSE_FIXEDDEPOSITACCOUNT",

  // RECURRING FIXED DEPOSIT
  READ_RECURRINGDEPOSITACCOUNT: "READ_RECURRINGDEPOSITACCOUNT",
  PREMATURECLOSE_RECURRINGDEPOSITACCOUNT:
    "PREMATURECLOSE_RECURRINGDEPOSITACCOUNT",
  CALCULATEINTEREST_RECURRINGDEPOSITACCOUNT:
    "CALCULATEINTEREST_RECURRINGDEPOSITACCOUNT",
  POSTINTEREST_RECURRINGDEPOSITACCOUNT: "POSTINTEREST_RECURRINGDEPOSIT ACCOUNT",
  WITHDRAWAL_RECURRINGDEPOSITACCOUNT: "WITHDRAWAL_RECURRINGDEPOSITACCOUNT",
  DEPOSIT_RECURRINGDEPOSITACCOUNT: "DEPOSIT_RECURRINGDEPOSITACCOUNT",

  // SAVINGS
  READ_SAVINGSACCOUNT: "READ_SAVINGSACCOUNT",
  READSTAFF_SAVINGSACCOUNT: "READSTAFF_SAVINGSACCOUNT",
  UPDATE_SAVINGSACCOUNTCHARGE: "UPDATE_SAVINGSACCOUNTCHARGE",
  UPDATEWITHHOLDTAX_SAVINGSACCOUNT: "UPDATEWITHHOLDTAX_SAVINGSACCOUNT",
  READ_ProgramDetails: "READ_ProgramDetails",
  READ_TxnRunningBalances: "READ_TxnRunningBalances",
  UNDOTRANSACTION_SAVINGSACCOUNT: "UNDOTRANSACTION_SAVINGSACCOUNT",

  // RECOVERY
  READ_RESCHEDULELOAN: "READ_RESCHEDULELOAN",
  READ_COLLECTIONSHEET: "READ_COLLECTIONSHEET",
  RECOVERYPAYMENT_LOAN: "RECOVERYPAYMENT_LOAN",
  READ_RESCHEDULED_LOANS: "READ_Rescheduled Loans",
  APPROVE_RESCHEDULELOAN: "APPROVE_RESCHEDULELOAN",
  ASSIGNSTAFF_GROUP: "ASSIGNSTAFF_GROUP",
  ASSIGNROLE_GROUP: "ASSIGNROLE_GROUP",
  SWITCH_RECOVERY_COLLECTION: "SWITCH_RECOVERY_COLLECTION_LOAN",
  READ_COLLECTION_INSTRUCTIONS_LOAN: "READ_COLLECTION_INSTRUCTIONS_LOAN",

  // ADMINISTRATION
  READ_CDL_CONFIGURATION: "READ_CDL_CONFIGURATION",
  CREATE_BANKACCOUNTTYPE: "CREATE_BANKACCOUNTTYPE",
  CREATE_BANKCLASSIFICATION: "CREATE_BANKCLASSIFICATION",
  CREATE_CENTER: "CREATE_CENTER",
  CREATE_CHARTSLAB: "CREATE_CHARTSLAB",
  CREATE_CHARTSLAB_CHECKER: "CREATE_CHARTSLAB_CHECKER",
  CREATE_TEMPLATE: "CREATE_TEMPLATE",
  CREATE_CENTER_CHECKER: "CREATE_CENTER_CHECKER",
  UPDATE_GRADE_ID_STAFF: "UPDATE_GRADE_ID_STAFF",

  // USER
  UPDATE_USER: "UPDATE_USER",
  DELETE_USER: "DELETE_USER",
  READ_USER: "READ_USER",
  CREATE_USER: "CREATE_USER",
  CREATE_USER_CHECKER: "CREATE_USER_CHECKER",

  // PRODUCT
  UPDATE_FIXEDDEPOSITACCOUNT: "UPDATE_FIXEDDEPOSITACCOUNT",
  UPDATE_FIXEDDEPOSITACCOUNT_CHECKER: "UPDATE_FIXEDDEPOSITACCOUNT_CHECKER",
  UPDATE_FIXEDDEPOSITPRODUCT: "UPDATE_FIXEDDEPOSITPRODUCT",
  UPDATE_FIXEDDEPOSITPRODUCT_CHECKER: "UPDATE_FIXEDDEPOSITPRODUCT_CHECKER",
  UPDATE_PRODUCTMIX: "UPDATE_PRODUCTMIX",
  CREATE_SAVINGSPRODUCT_CHECKER: "CREATE_SAVINGSPRODUCT_CHECKER",
  UPDATE_LOANPRODUCT: "UPDATE_LOANPRODUCT",
  UPDATE_LOANPRODUCT_CHECKER: "UPDATE_LOANPRODUCT_CHECKER",
  CREATE_LOANPRODUCT_CHECKER: "CREATE_LOANPRODUCT_CHECKER",
  CREATE_SAVINGSPRODUCT: "CREATE_SAVINGSPRODUCT",
  UPDATE_SAVINGSPRODUCT: "UPDATE_SAVINGSPRODUCT",
  CREATE_DIVIDEND_SHAREPRODUCT: "CREATE_DIVIDEND_SHAREPRODUCT",
  CREATE_DIVIDEND_SHAREPRODUCT_CHECKER: "CREATE_DIVIDEND_SHAREPRODUCT_CHECKER",

  // EDR
  READ_OFFICETRANSACTION: "READ_OFFICETRANSACTION",
  CREATE_FCMB: "CREATE_FCMB",
  READ_EDRNOTE: "READ_EDRNOTE",
  CREATE_EDR: "CREATE_EDR",
  CREATE_EDRNOTE: "CREATE_EDRNOTE",
  SETTLECASHFROMCASHIER_TELLER: "SETTLECASHFROMCASHIER_TELLER",
  ALLOCATECASHTOCASHIER_TELLER: "ALLOCATECASHTOCASHIER_TELLER",
  DISBURSEFAILED_LOAN: "DISBURSEFAILED_LOAN",
  ALLOCATECASHIER_TELLER: "ALLOCATECASHIER_TELLER",
  READ_Branch_Expected_Cash_Flow: "READ_Branch Expected Cash Flow",
  PROCESS_EDR: "PROCESS_EDR",
  PROCESS_REPAYMENT_EDR: "PROCESS_REPAYMENT_EDR",
  VIEW_REMITTA_MANDATE_LOAN: "VIEW_REMITTA_MANDATE_LOAN",
  UPLOAD_REMITTA_MANDATE_LOAN: "UPLOAD_REMITTA_MANDATE_LOAN",
  DOWNLOAD_REMITTA_MANDATE_LOAN: "DOWNLOAD_REMITTA_MANDATE_LOAN",
  READ_RECONCILIATION_EDR: "READ_RECONCILIATION_EDR",
  READ_EDRPROCESSING: "READ_EDRPROCESSING",
  READ_OVERDRAFTAPPLICATIONS: "READ_OVERDRAFTAPPLICATIONS",
  CREATE_SAVINGSACCOUNTOVERDRAFT: "CREATE_SAVINGSACCOUNTOVERDRAFT",

  // TELESALES
  READ_TELESALES: "READ_TELESALES",
  CREATE_PRODUCTMIX: "CREATE_PRODUCTMIX",
  UPDATE_LOANNOTE: "UPDATE_LOANNOTE",
  UPDATE_LOANNOTE_CHECKER: "UPDATE_LOANNOTE_CHECKER",
  UPDATE_TELESALES: "UPDATE_TELESALES",
  ASSIGNOFFICER_TELESALES: "ASSIGNOFFICER_TELESALES",
  READ_Active_Loans_Summary: "READ_Active Loans - Summary",

  // HOT LEADS
  READ_SCHEDULER: "READ_SCHEDULER",
  READ_SMS: "READ_SMS",
  READ_SMSCAMPAIGN: "READ_SMSCAMPAIGN",
  CREATE_CLIENTIDENTIFIER: "CREATE_CLIENTIDENTIFIER",
  CREATE_CLIENTIDENTIFIER_CHECKER: "CREATE_CLIENTIDENTIFIER_CHECKER",
  CREATE_CLIENTIMAGE: "CREATE_CLIENTIMAGE",

  // DROP OFF
  READ_Active_Loans_Details: "READ_Active Loans - Details",
  READ_Active_Loan_Clients_Email: "READ_Active Loan Clients - Email",
  READ_Active_Loan_Summary_per_Branch: "READ_Active Loan Summary per Branch",

  // UNDERWRITER
  APPROVE_DIVIDEND_SHAREPRODUCT: "APPROVE_DIVIDEND_SHAREPRODUCT",
  APPROVE_DIVIDEND_SHAREPRODUCT_CHECKER:
    "APPROVE_DIVIDEND_SHAREPRODUCT_CHECKER",
  APPROVEADDITIONALSHARES_SHAREACCOUNT: "APPROVEADDITIONALSHARES_SHAREACCOUNT",
  REASSIGN_APPROVALHISTORY: "REASSIGN_APPROVALHISTORY",
  VIEW_TEAMLEAD_APPROVALHISTORY: "VIEW_TEAMLEAD_APPROVALHISTORY",
  VIEW_LOANCONFIGURATION: "VIEW_LOANCONFIGURATION",
  CREATE_LOANCONFIGURATION: "CREATE_LOANCONFIGURATION",
  UPDATE_LOANCONFIGURATION: "UPDATE_LOANCONFIGURATION",

  // DISBURSEMENT
  LINK_ACCOUNT_TO_POCKET: "LINK_ACCOUNT_TO_POCKET",
  // PAY_CLIENTCHARGE: "PAY_CLIENTCHARGE",
  // PAY_CLIENTCHARGE_CHECKER: "PAY_CLIENTCHARGE_CHECKER",
  PAY_LOANCHARGE: "PAY_LOANCHARGE",
  PAY_SAVINGSACCOUNTCHARGE: "PAY_SAVINGSACCOUNTCHARGE",
  READ_IMPORT: "READ_IMPORT",
  READ_Income_Statement: "READ_Income Statement",
  RECONCILE_DISBURSEMENT_BANK_STATEMENT:
    "RECONCILE_DISBURSEMENT_BANK_STATEMENT",
  MANUALLY_RECONCILE_DISBURSEMENT_BANK_STATEMENT:
    "MANUALLY_RECONCILE_DISBURSEMENT_BANK_STATEMENT",

  // ORGANISATIONS
  CREATE_OFFICE: "CREATE_OFFICE",
  CREATE_OFFICETRANSACTION: "CREATE_OFFICETRANSACTION",
  CREATE_STAFF: "CREATE_STAFF",
  CREATE_STANDINGINSTRUCTION: "CREATE_STANDINGINSTRUCTION",
  READ_PASSWORD_PREFERENCES: "READ_PASSWORD_PREFERENCES",
  CREATE_PROVISIONCRITERIA: "CREATE_PROVISIONCRITERIA",
  READ_FUND: "READ_FUND",
  BULKREASSIGN_LOAN: "BULKREASSIGN_LOAN",
  READ_WORKINGDAYS: "READ_WORKINGDAYS",
  READ_PAYMENTTYPE: "READ_PAYMENTTYPE",
  CREATE_SMSCAMPAIGN: "CREATE_SMSCAMPAIGN",
  CREATE_SMSCAMPAIGN_CHECKER: "CREATE_SMSCAMPAIGN_CHECKER",
  UPDATEEMPLOYER_LOAN: "UPDATEEMPLOYER_LOAN",
  EDR_RECONCILLATION_DETAILS: "EDR_RECONCILLATION_DETAILS",
  EDR_RECONCILLATION_DASHBOARD: "EDR_RECONCILLATION_DASHBOARD",
  EDR_RECONCILLATION: "EDR_RECONCILLATION",
  OPEN_CLOSE_RECOVERY_COLLECTION_LOAN: "OPEN_CLOSE_RECOVERY_COLLECTION_LOAN",

  // FAQ
  CREATE_FAQ: "CREATE_FAQ",
  READ_FAQ: "READ_FAQ",
  UPDATE_FAQ: "UPDATE_FAQ",
  DELETE_FAQ: "DELETE_FAQ",

  // PAYPOINT
  READ_PAYPOINT: "READ_PAYPOINT",

  // PUSH NOTIFICATIONS
  READ_PUSH_NOTIFICTION: "READ_PUSH_NOTIFICTION",
  SEND_PUSH_NOTIFICTION: "SEND_PUSH_NOTIFICTION",

  WAIVE_LOANCHARGE: "WAIVE_LOANCHARGE",

  //WACS
  APPROVE_THIRD_PARTY_LOAN: "APPROVE_THIRD_PARTY_LOAN",
  REJECT_THIRD_PARTY_LOAN: "REJECT_THIRD_PARTY_LOAN",

  //IMPAIRMENT
  READ_IMPAIRMENT: "READ_IMPAIRMENT",

  //Business Banking
  READ_GROUP: "READ_GROUP",
  CREATE_GROUP: "CREATE_GROUP",
  UPDATE_GROUP: "UPDATE_GROUP",
  UNASSIGNSTAFF_GROUP: "UNASSIGNSTAFF_GROUP",
  ACTIVATE_GROUP: "ACTIVATE_GROUP",
  CLOSE_GROUP: "CLOSE_GROUP",
  //TRANSACTION
  RELEASEAMOUNT_SAVINGSACCOUNT: "RELEASEAMOUNT_SAVINGSACCOUNT",
};

export const DOCUMENT_TYPE = {
  PDF: "pdf",
  IMAGE: "image",
};

export const CUSTOMER_TYPE_NAME_ENUM = {
  1: "clients",
  2: "employer",
  39: "vendor",
};

export const CUSTOMER_TYPE_TO_ENUM = {
  1: RouteEnum.CRM_CLIENTS,
  2: RouteEnum.CRM_EMPLOYER,
  39: RouteEnum.CRM_VENDOR,
};

export const LOAN_WRITEOFF_STATUS_ENUM = {
  LOAN_WRITEOFF_ACTIVE: 603,
  LOAN_WRITEOFF: 601,
};

export const EMPLOYER_SECTOR_ENUM = {
  PUBLIC: 18,
};

export const BANK_DEFAULT_ICON =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24'%3E%3Cpath fill='%23fff' d='M12.512 2.634a1.74 1.74 0 0 0-1.023 0l-2.986.918A16.5 16.5 0 0 0 4.178 5.61c-.848.567-.446 1.89.574 1.89h14.496c1.02 0 1.422-1.323.575-1.89a16.5 16.5 0 0 0-4.326-2.058zM4.25 21a.75.75 0 0 1 .75-.75h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75m2-4a.75.75 0 0 0 1.5 0v-6a.75.75 0 0 0-1.5 0zm5.75.75a.75.75 0 0 1-.75-.75v-6a.75.75 0 0 1 1.5 0v6a.75.75 0 0 1-.75.75m4.25-.75a.75.75 0 0 0 1.5 0v-6a.75.75 0 0 0-1.5 0z' stroke-width='0.5' stroke='%23fff'/%3E%3C/svg%3E";
